// Constants
import { HTTP_CODES } from "@/constants/httpCodes.ts";

export interface ErrorResponse {
  response?: {
    status?: number;
  };
  message?: string;
  config?: {
    disabledAuthorizationError?: boolean;
  };
}

export function getStatusError(error: ErrorResponse): number | undefined {
  return error?.response?.status;
}

export function isErrorUnauthorized(error: ErrorResponse): boolean {
  let statusCode = getStatusError(error);
  return statusCode === HTTP_CODES.UNAUTHORIZED || statusCode === HTTP_CODES.FORBIDDEN;
}

export function isNetworkError(error: ErrorResponse): boolean {
  return error.message === "Network Error";
}
